import { defineStore } from "pinia";
import AlertifyVueService from "../services/AlertifyService";
import IAlertifyService from "../services/IAlertifyService";
import LoginService from "../services/login/LoginService";
import CService from "../services/base/CService";
import AppUIManagerService from "../services/AppUIManagerService";
import { StorageService } from "../services/StorageService";
import IParamServices from "../services/IParamServices";
import { useMainStore } from "./main-store";
import EmployeService from "../services/employees/EmployeService";
import QuotaTypeService from "../services/sys/QuotaTypeService";
import ProductService from "../services/sys/ProductService";
import CustomerService from "../services/sys/CustomerService";
import GenericService from "../services/base/GenericService";
import ContractService from "../services/sys/ContractService";
import InvoiceService from "../services/sys/InvoiceService";
import AgreementService from "../services/sys/AgreementService";
import AppSystemSettingsService from "../services/sys/AppSystemSettingsService";
import ParameterService from "../services/sys/ParameterService";
import HomeService from "../services/sys/HomeService";
import ReportsService from "../services/sys/ReportsService";

export const useServicesFactoryStore = defineStore('servicesfactorystore', 
{
  state: () =>
  { 
    const mainStore = useMainStore();   
    const alertifyService:IAlertifyService = new AlertifyVueService();   
    const param:IParamServices = {appConfig:mainStore.appConfig,alertify:alertifyService};
    const cService:CService = new CService(process.env.VUE_APP_SECRET_KEY? process.env.VUE_APP_SECRET_KEY:'',
                                           process.env.VUE_APP_SECRET? process.env.VUE_APP_SECRET:'');
    
    const loginService:LoginService = new LoginService(param);
    const employeeService:EmployeService = new EmployeService(param);
    const appUIManagerService:AppUIManagerService = new AppUIManagerService(alertifyService);
    const quotaTypeService: QuotaTypeService = new QuotaTypeService(param);
    const productService: ProductService  = new ProductService(param);
    const customerService:CustomerService = new CustomerService(param);
    const genericService:GenericService = new GenericService(param);
    const contractService:ContractService= new ContractService(param);
    const invoiceService:InvoiceService = new InvoiceService(param);
    const agreementService:AgreementService = new AgreementService(param);
    const appSystemSettingsService:AppSystemSettingsService = new AppSystemSettingsService(param);
    const parameterService:ParameterService = new ParameterService(param);
    const homeService:HomeService = new HomeService(param);
    const reportsService:ReportsService = new ReportsService(param);
    const storageService = new StorageService();
    return {
      Services:
      {
        cService,
        alertifyService,
        loginService,
        employeeService,
        appUIManagerService,
        storageService,
        quotaTypeService,
        productService,
        customerService,
        genericService,
        contractService,
        invoiceService,
        agreementService,
        appSystemSettingsService,
        parameterService,
        homeService,
        reportsService
      }
    }
  },
  getters: 
  {    
    getCService:(state):CService => state.Services.cService as CService,   
    getAlertifyService: (state):IAlertifyService => state.Services.alertifyService as IAlertifyService,
    getLoginService: (state):LoginService => state.Services.loginService as LoginService,
    getAppUIManagerService: (state):AppUIManagerService => state.Services.appUIManagerService as AppUIManagerService,
    getStorageService: (state):StorageService => state.Services.storageService as StorageService,
    getEmployeService: (state):EmployeService => state.Services.employeeService as EmployeService,
    getQuotaTypeService: (state): QuotaTypeService => state.Services.quotaTypeService as QuotaTypeService,
    getProductService: (state): ProductService => state.Services.productService as ProductService,
    getCustomerService: (state): CustomerService => state.Services.customerService as CustomerService,
    getGenericService: (state): GenericService => state.Services.genericService as GenericService,
    getContractService: (state): ContractService => state.Services.contractService as ContractService,
    getinvoiceService: (state):InvoiceService=> state.Services.invoiceService as InvoiceService,
    getAgreementService: (state):AgreementService=> state.Services.agreementService as AgreementService,
    getAppSystemSettingsService: (state):AppSystemSettingsService=> state.Services.appSystemSettingsService as AppSystemSettingsService,
    getParameterService: (state):ParameterService=> state.Services.parameterService as ParameterService,
    getHomeService: (state):HomeService=> state.Services.homeService as HomeService,
    getReportsService:(state):ReportsService=> state.Services.reportsService as ReportsService
  },
  actions:
  {
    //getService<T>(type: T){}
  },
});